export enum ResultsView {
  Grid = "grid",
  Table = "table",
}
